import React, { useEffect, useState } from 'react';
import styles from './Pdl.module.css';
import DonutCharts from './DonutCharts';
import { getTopKips } from '../../../services/summary/summaryService';
import DumbbellChart from '../Project_Page/Dumbell_Chart';
import {
  Info
} from 'lucide-react';


const Kpis = ({ title, value ,activeTab }) => {

  const [Kpidata, setKpidata] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [dataFormat, setDataFormat] = useState([
    { title: 'Can', id: 'can' },
    { title: 'Event', id: 'event' },
    { title: 'Telemetry', id: 'telemetry' },
    { title: 'Total vehicles', id: 'driving' },
    { title: 'Driven Vehicles', id: 'total_vehicle' },
  ])

  const [filterdata, setFillterData] = useState({
    "startDate": "2026-03-06"
  })

  const [showPopup, setShowPopup] = useState(false);
  const [selectedKpi, setSelectedKpi] = useState(null);

  useEffect(() => {
    getKpiFunction()
  }, [activeTab])

  async function getKpiFunction() {
    await getTopKips({ filterdata,activeTab })
      .then(res => {
        setKpidata({
          ...res, combined: res?.COMBINED?.n1,
          combinedN2: res?.COMBINED?.n2,
          change: res?.COMBINED?.change,
        })
      })
      .catch(err => console.log("err"))
  }

  const handleOpenPopup = (item) => {
    setSelectedKpi(item);
    setShowPopup(true);
  };

  return (
    <>
      {/* KPI SECTION */}
      {/* <div className="px-3 pt-3"> */}
      <div className="row g-3">
        {dataFormat?.map((item, index) => {

          const changeValue = Kpidata?.change?.[item.id] || 0;
          return (
            <>
              <div key={index} className="col">
                <div className={`card ${styles.kpiCard}`}>
                  {/* <div className='d-flex align-items-center justify-content-center'> */}
                  <div className='d-flex align-items-center justify-content-start'>
                    <div className="text-start ml-4">
                      <div className={styles.kpiTitle}>
                        {item.title}
                      </div>
                      <div className={styles.kpiValue}>
                        {Kpidata?.combined?.[item.id]}
                      </div>

                      <div className={`${styles.kpiTrend} ${changeValue >= 0 ? "text-success" : "text-danger"}`}>
                        <span>
                          {changeValue >= 0 ? "▲" : "▼"}
                        </span>

                        <span className={`${styles.kpiSize} ${changeValue >= 0 ? "text-success" : "text-danger"}`} >
                          {Math.abs(changeValue)}%
                        </span>
                        <Info className='text-info ml-1' size={14}  onClick={() => handleOpenPopup(item)}/>
                      </div>

                      <div className={styles.kpiValue2}>
                        {item.value}
                      </div>
                    </div>
                    <div style={{ width: 100 }} >
                      <DonutCharts
                        data={activeTab =="pdl"?[
                          { label: "CESL", value: Kpidata?.CESL?.n1?.[item.id] || 0 },
                          { label: "KRATOS", value: Kpidata?.KRATOS?.n1?.[item.id] || 0 },
                          { label: "ORION", value: Kpidata?.ORION?.n1?.[item.id] || 0 },
                        ]:
                      [ { label: "ACE", value: Kpidata?.ACE?.n1?.[item.id] || 0 },
                      { label: "CORAL", value: Kpidata?.CORAL?.n1?.[item.id] || 0 },
                      ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        })}
      </div>
      {/* Popup rendered outside the row */}
      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popupContent}>
            <button className={styles.closeBtn} onClick={() => setShowPopup(false)}>✕</button>
            <h4 className='fw-bolder'>{selectedKpi?.title}</h4>
            <DumbbellChart kpi={selectedKpi} prevValue={Kpidata.combined?.[selectedKpi?.id]} prevValueN2={Kpidata.combinedN2?.[selectedKpi?.id]} />
          </div>
        </div>
      )}
    </>
  )
};
export default React.memo(Kpis);